import React, { FC } from 'react';
import { Box, Container, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Image from 'blog/components/Image';

interface imageSectionProps {
  image: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: theme.spacing(15),
    marginBottom: theme.spacing(12),
  },
  image: {
    maxHeight: 330,
    maxWidth: '100%',
  },
}));

const NewsImageSection: FC<imageSectionProps> = ({ image }) => {
  const classes = useStyles({ image });

  return (
    <Container fixed className={classes.root}>
      <Box display="flex" justifyContent="center">
        <Image src={image} alt={image} className={classes.image} width={1285} height={550} />
      </Box>
    </Container>
  );
};

export default NewsImageSection;
